import SiNo from "@shared/enums/si-no.enum";
import ITipo, { ITipoDocumento } from "./tipo.interface";

export class TipoDocumento implements ITipoDocumento {
    codigo: number;
    nombre: string;
    requerido: number;
    ingresado?: number; // id del documento ingresado
    obligatorio: ITipo;
    ruta: string = 'https://www.princexml.com/samples/icelandic/dictionary.pdf';

    get requerido_escrito() {
        return this.requerido === SiNo.si ? "Si" : "No";
    }

    get ingresado_escrito() {
        return this.ingresado > 0 ? "Ingresado" : "No ingresado";
    }
}